// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wylie Vets Brand Colours — THE single source of truth for the React app.
 *
 * There used to be two more palettes: styles/brand-colors.css and
 * styles/brand-colors.js. Neither was imported anywhere, so neither reached a
 * screen, and brand-colors.css had drifted to a different coral (#e07856 vs the
 * #f05f57 actually rendered). Picking a colour from it produced the wrong result.
 * Both were deleted on 2026-07-30 — put new colours HERE.
 *
 * The standalone candidate forms in public/*.html necessarily carry their own
 * copies, since they are plain HTML with no build step. If a brand colour changes,
 * they need updating too.
 */
:root {
  --wylie-white: #ffffff;
  --wylie-black: #201e1f;
  --wylie-pink: #dc2565;
  --wylie-cyan: #00ffff;
  --wylie-purple: #500778;
  --wylie-green: #1c5f36;
  --wylie-coral: #f05f57;
  --wylie-blue: #288bcd;

  /* Part 1 (Interview) pane colour — the ONE place to change it: the frame and
     title (PART1A_COLOR in CandidateDetail.js), every yellow in the pane, and the
     Part 1 heading on the Help page. */
  --part1-color: #F7D002;

  /* Part 4 / Part 5 frame colours — also the button green and purple (App.css),
     since the brand green and purple are too dark for an outlined button. */
  --part4-color: #28a745;
  --part5-color: #9b4fc4;

  /* Offer Declined amber — the Dashboard figure and the "Mark as Offer Declined"
     button, kept apart from Rejected's coral (contrast notes in Dashboard.css). */
  --declined-color: #d99a2b;

  /* App theme colours */
  --color-bg-dark: #1a1a1a;
  --color-bg-card: #2a2a2a;
  --color-bg-hover: #333333;
  --color-border: #444444;
  --color-text-light: #e0e0e0;
  --color-text-muted: #999999;

  /* Aliases for names already in use around the app. These were referenced but
   * never defined, so the declarations using them were invalid and silently fell
   * back to whatever was inherited. Defined here so those styles are deliberate.
   * Values chosen to preserve what was already on screen. */
  --color-text: var(--color-text-light);
  --color-text-primary: var(--color-text-light);
  --color-bg-input: #1e1e1e; /* was the inline fallback in EmailPreviewModal.css */
  --color-bg: var(--color-bg-dark);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--color-bg-dark);
  color: var(--color-text-light);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;EAWE;AACF;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;;EAErB;;uCAEqC;EACrC,sBAAsB;;EAEtB;4EAC0E;EAC1E,sBAAsB;EACtB,sBAAsB;;EAEtB;kFACgF;EAChF,yBAAyB;;EAEzB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;;EAE3B;;;4DAG0D;EAC1D,qCAAqC;EACrC,6CAA6C;EAC7C,yBAAyB,EAAE,qDAAqD;EAChF,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,2DAA2D;EAC3D,mCAAmC;EACnC,kCAAkC;EAClC,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE;aACW;AACb","sourcesContent":["/* Wylie Vets Brand Colours — THE single source of truth for the React app.\n *\n * There used to be two more palettes: styles/brand-colors.css and\n * styles/brand-colors.js. Neither was imported anywhere, so neither reached a\n * screen, and brand-colors.css had drifted to a different coral (#e07856 vs the\n * #f05f57 actually rendered). Picking a colour from it produced the wrong result.\n * Both were deleted on 2026-07-30 — put new colours HERE.\n *\n * The standalone candidate forms in public/*.html necessarily carry their own\n * copies, since they are plain HTML with no build step. If a brand colour changes,\n * they need updating too.\n */\n:root {\n  --wylie-white: #ffffff;\n  --wylie-black: #201e1f;\n  --wylie-pink: #dc2565;\n  --wylie-cyan: #00ffff;\n  --wylie-purple: #500778;\n  --wylie-green: #1c5f36;\n  --wylie-coral: #f05f57;\n  --wylie-blue: #288bcd;\n\n  /* Part 1 (Interview) pane colour — the ONE place to change it: the frame and\n     title (PART1A_COLOR in CandidateDetail.js), every yellow in the pane, and the\n     Part 1 heading on the Help page. */\n  --part1-color: #F7D002;\n\n  /* Part 4 / Part 5 frame colours — also the button green and purple (App.css),\n     since the brand green and purple are too dark for an outlined button. */\n  --part4-color: #28a745;\n  --part5-color: #9b4fc4;\n\n  /* Offer Declined amber — the Dashboard figure and the \"Mark as Offer Declined\"\n     button, kept apart from Rejected's coral (contrast notes in Dashboard.css). */\n  --declined-color: #d99a2b;\n\n  /* App theme colours */\n  --color-bg-dark: #1a1a1a;\n  --color-bg-card: #2a2a2a;\n  --color-bg-hover: #333333;\n  --color-border: #444444;\n  --color-text-light: #e0e0e0;\n  --color-text-muted: #999999;\n\n  /* Aliases for names already in use around the app. These were referenced but\n   * never defined, so the declarations using them were invalid and silently fell\n   * back to whatever was inherited. Defined here so those styles are deliberate.\n   * Values chosen to preserve what was already on screen. */\n  --color-text: var(--color-text-light);\n  --color-text-primary: var(--color-text-light);\n  --color-bg-input: #1e1e1e; /* was the inline fallback in EmailPreviewModal.css */\n  --color-bg: var(--color-bg-dark);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--color-bg-dark);\n  color: var(--color-text-light);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
